import React from 'react';
import type { FC } from 'react';
import kebabCase from 'lodash/kebabCase.js';
import { TextInput } from '@wix/cli-ui-kit';
import { getDashboardModalExtensionsDir } from '@wix/cli-astro-definitions';
import { useProjectModel } from '../../../model.js';
import {
  composeValidations,
  pathAvailableValidation,
  pathValidation,
  useValidation,
} from '../../../dev-center/components/validations/index.js';
import { useWixCliAstroBi } from '../../../bi/index.js';

import { useWizardStep } from '../Wizard.js';

export const ChooseTitleStep: FC<{ onSubmit: (value: string) => void }> = ({
  onSubmit,
}) => {
  const bi = useWixCliAstroBi();
  const { isActive, goToNextStep } = useWizardStep();

  return (
    <TextInput
      isActive={isActive}
      label={'Modal title:'}
      placeholder={'My Modal'}
      onSubmit={(modalTitle) => {
        bi.cliFlowStepAnswered({
          question: 'Modal title:',
          questionKey: 'generate_command.dashboard_modal.choose_title',
          answer: modalTitle,
          additionalInfo: { extensionType: 'dashboard modal' },
        });
        onSubmit(modalTitle);
        goToNextStep();
      }}
    />
  );
};

export const ChooseFolderStep: FC<{
  onSubmit: (value: string) => void;
  modalFolder: string | undefined;
  modalTitle: string | undefined;
}> = ({ onSubmit, modalTitle, modalFolder }) => {
  const bi = useWixCliAstroBi();
  const { model } = useProjectModel();
  const { isActive, goToNextStep } = useWizardStep();

  const defaultModalFolder = kebabCase(modalTitle);

  const validateDashboardFolder = useValidation(
    composeValidations([
      [
        pathAvailableValidation(
          getDashboardModalExtensionsDir(model.projectFolder)
        ),
        'The modal folder must be unique. Select a folder name that has not been used yet in your application.',
      ],
      [
        pathValidation,
        'The modal folder must be a valid path ([a-z0-9-/]+) and must not start with a dot.',
      ],
    ])
  );

  return (
    <TextInput
      isActive={isActive}
      label={'Enter the folder name for the new modal:'}
      placeholder={modalFolder ?? defaultModalFolder}
      onSubmit={(value) => {
        bi.cliFlowStepAnswered({
          question: 'Enter the folder name for the new modal:',
          questionKey: 'generate_command.dashboard_modal.choose_folder',
          answer: value,
          additionalInfo: { extensionType: 'dashboard modal' },
        });
        onSubmit(value);
        goToNextStep();
      }}
      validate={validateDashboardFolder}
    />
  );
};
